// React
import React, { useEffect, useState } from 'react';
import classes from './vitrin.module.scss';
import { Card, CardHeader, Grid, Typography, CardContent, Button, TextField, Checkbox, Divider } from '@material-ui/core';
import { mdiCameraPlus, mdiDeleteOutline, mdiMinusCircleOutline, mdiPaperclip, mdiPlusCircle } from '@mdi/js';
import Icon from '@mdi/react';
import ProductRepository from 'client-sdk/src/Repository/product-repository';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import handleNotfication from '../../../utils/handleNotfication';
import handleError from '../../../utils/handleError';
import { useHistory } from 'react-router-dom';

const filter = createFilterOptions();

type Props = {
  id: number;
  submit: any;
  setConfirm: (state: boolean) => void;
  setVitrinSubmit: (state: number) => void;
  variant: any
};

export default function Vitrin(props: Props) {
  const history = useHistory();
  const file = new FormData()
  const [variant, setVariant] = useState({
    id: null,
    name: "",
    price: "",
    description: "",
    files: []
  })
  const [category, setCategory] = useState(null)
  const [isInVitrin, setIsInVitrin] = useState(false)
  const [categoryList, setCategoryList] = useState([])
  const [editMode, setEditMode] = useState(false)
  const partnerId = localStorage.getItem("partnerId")
  useEffect(() => {
    getCategories()
    if (props.submit == 2) {
      formSubmit()
    }
  }, [props.submit])

  //All 
  const getCategories = async () => {
    try {
      const response = await ProductRepository.getVitrinCategories({})
      setCategoryList(response.data)
      getVariants(response.data)
    } catch (err) {
      handleError(err.response)
    }
  }

  const getVariants = async (categories: []) => {
    try {
      const response = await ProductRepository.getVitrinProduct({ payload: { 'variantId.equals': props.id } });
      if (response.data.length > 0) {
        const product = await ProductRepository.getVitrinProductWithId({ payload: { id: response.data[0].id } });
        const category = categories.filter(el => el.id == response.data[0].categoryId)[0]
        setCategory(category)
        setEditMode(true)
        setIsInVitrin(true)
        setVariant({
          id: product.data.id,
          name: product.data.name,
          price: product.data.price,
          description: product.data.description,
          files: product.data.imageNames
        })
        product.data.imageNames.forEach((el: any, index: number) => {
          getImage({ ...product.data, files: product.data.imageNames }, index)
        })
      }
    } catch (err) {
      handleError(err.response)
    }
  }

  const getImage = (product: any, index: number) => {
    let newVariant = { ...product }

    ProductRepository.getImagefromVitrin({ payload: { id: product.id, fileName: product.imageNames[index] } })
      .then(response => {
        newVariant.files[index] = { url: response.data, type: response.headers['content-type'], name: product.imageNames[index] }
        setVariant(newVariant)
      }).catch(err => {
        handleError(err.response)
      })
  }

  const onFormChange = (e: any) => {
    let newVariant = { ...variant }
    newVariant[e.target.name] = e.target.value
    setVariant(newVariant)
  }

  const formSubmit = async () => {
    if (editMode) {
      if (isInVitrin) {
        editProduct()
      } else {
        removeProduct()
      }
      return;
    }
    if (isInVitrin) {
      saveProduct()
    }
  }

  //Edit
  const uploadImage = async (event: any) => {
    let newVariant = { ...variant }
    let fileUrl = event.target.files[0]
    try {
      if (event.target.files[0]) {
        file.append("file", event.target.files[0])
        const response = await ProductRepository.uploadImageToVitrin({ payload: { id: variant.id, body: file } })
        newVariant.files.push({ url: URL.createObjectURL(fileUrl), name: response.data[0].imageName })
        setVariant(newVariant)
      }
    } catch (err) {
      handleError(err.response)
    }


  }

  const removeProduct = async () => {
    try {
      const response = await ProductRepository.removeVitrinProduct({ payload: { id: variant.id } });
      setVariant({
        id: null,
        name: "",
        price: "",
        description: "",
        files: []
      })
    } catch (err) {
      handleError(err.response)
    }
  }

  const editProduct = async () => {
    const body = {
      id: variant.id,
      name: variant.name,
      variantId: props.id,
      price: variant.price,
      description: variant.description,
      categoryId: category.id
    }
    try {
      const response = await ProductRepository.updateVitrinProduct({ payload: { body, id: variant.id } });
    } catch (err) {
      handleError(err.response)
    }
    finally {
      history.push('/your-products');
    }
  }

  const removeImage = async (fileName: string, index: number) => {
    try {
      const response = await ProductRepository.removeImagefromVitrin({ payload: { id: variant.id, fileName } })
      removeFile(index)
    } catch (err) {
      handleError(err.response)
    }
  }

  const formConfirm = () => {
    if (!Boolean(variant.name) || !Boolean(variant.price) || !category) {
      handleNotfication("اطلاعات بخش ویترین صحیح نیست", "error")
      return false
    }
    return true
  }

  //Create
  const saveProduct = async () => {
    const body = {
      id: props.variant.productId,
      name: variant.name,
      variantId: props.id,
      price: variant.price,
      description: variant.description,
      categoryId: category.id
    }
    try {
      const response = await ProductRepository.CreateVitrinProduct({ payload: { body } });
      if (variant.files.length > 0) {
        variant.files.forEach(el => {
          file.append("file", el.file)
        })
        await ProductRepository.uploadImageToVitrin({ payload: { id: response.data.id, body: file } })
      }
    } catch (err) {
      handleError(err.response)
    }
  }

  const handleChangeFileInput = (event: any) => {
    let newVariant = { ...variant }
    if (event.target.files[0]) {
      newVariant.files.push({ file: event.target.files[0], url: URL.createObjectURL(event.target.files[0]) })
      setVariant(newVariant)
    }
  };

  const removeFile = (index: number) => {
    let newVariant = { ...variant }
    newVariant.files.splice(index, 1);
    setVariant(newVariant)
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={
          <Grid>
            <Typography className={classes.vitrinCard}>
              ویترین
            </Typography>
          </Grid>
        }
      />
      <CardContent className={classes.cardContentOrder}>
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          alignItems="flex-start"
        >
          <div className={classes.item}>
            <span className={classes.label}>
              <Checkbox
                checked={isInVitrin}
                onChange={e => {
                  setIsInVitrin(e.target.checked);
                }}
                color="secondary"
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
                data-cy="fulfillmentServiceCheckBox"
              />
            </span>

            <div
              style={{
                width: '100%',
                marginTop: '20px',
              }}
            >
              <p className={classes.textBold}>فروش کالا در ویترین روناد <span className={classes.textMuted}>(با فعال کردن این گزینه و وارد کردن اطلاعات، کالای شما به فروشندگان دیگر نمایش داده خواهد شد و امکان سفارش گذاشتن روی کالای شما برای دیگران وجود خواهد داشت)</span></p>
            </div>
          </div>
        </Grid>
        {isInVitrin &&
          <>
            <Divider style={{
              margin: '20px 0',
            }} />
            <Grid container lg={3} md={12}>
              <Autocomplete
                fullWidth
                id="categoryName"
                noOptionsText="موردی یافت نشد"
                autoComplete
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
                onChange={(_, newValue: any) => {
                  setCategory(newValue)
                }}
                filterOptions={(options, params: any) => {
                  const filtered = filter(
                    options,
                    params
                  ) as any;

                  if (params.inputValue !== '') {
                    filtered.push({
                      inputValue: params.inputValue,
                      name: `اضافه کردن "${params.inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                options={
                  categoryList.length
                    ? categoryList
                    : []
                }
                getOptionLabel={options => options.name}
                renderOption={option => (
                  <span style={{ display: 'block' }}>
                    <span>{option?.name}</span>
                  </span>
                )}
                loadingText="در حال بارگذاری"
                // loading={loading}
                value={category!}
                defaultValue={{
                  id: 2,
                  name: 'دیجیتال',
                }}
                renderInput={params => (
                  <TextField
                    type="search"
                    variant="outlined"
                    {...params}
                    label="دسته‌بندی روناد"
                    id="categoryName"
                    name="categoryName"
                    // error={!!errors.categoryName}
                    margin="normal"
                    style={{ marginTop: 0, marginBottom: 0 }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {/* {loading ? (
                      <CircularProgress
                        color="inherit"
                        size={20}
                      />
                    ) : null} */}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Divider style={{
              margin: '20px 0',
              width: '100%'
            }} />
            <Grid container lg={12} md={12} className={classes.cardContent}>
              <Grid item lg={3} md={3} xs={12}>
                <div className={classes.item}>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    label="نام در ویترین"
                    id="name"
                    name="name"
                    // error={!!errors.name}
                    style={{ margin: "0 8px" }}
                    value={variant.name}
                    onChange={onFormChange}
                  />
                </div>
              </Grid>
              <Grid item lg={3} md={3} xs={12}>
                <div className={classes.item}>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    label="قیمت(تومان)"
                    id="price"
                    name="price"
                    // error={!!errors.price}
                    style={{ margin: "0 8px" }}
                    value={variant.price}
                    onChange={onFormChange}
                  />
                </div>
              </Grid>
              <Grid item lg={8} md={8} xs={12}>
                <div className={classes.item}>
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    label="توضیحات"
                    multiline
                    rows={4}
                    id="description"
                    name="description"
                    // error={!!errors.description}
                    style={{ margin: "0 8px" }}
                    value={variant.description}
                    onChange={onFormChange}
                  />
                </div>
              </Grid>
              <Grid
                container
                xs={12}
                lg={12}
                alignItems="stretch"
              >
                {
                  variant.files?.map((file, index) => (
                    <Grid item lg={1} xs={6}>
                      <div className={classes.item}>
                        <br />
                        <div className={classes.imgContainer}>
                          {/* {getImage(variant, index)} */}
                          {file.type ? (
                            <img src={`data:${file.type};charset=utf-8;base64,${file.url}`} className={classes.img} />
                          ) : (<img src={file.url} className={classes.img} />)}
                          {/* <div>
                            {file.url}
                          </div> */}
                          <Icon
                            color={'#000'}
                            path={mdiDeleteOutline}
                            size={2}
                            className={classes.icon}
                            onClick={() => {
                              if (editMode) {
                                removeImage(file.name, index)
                              } else {
                                removeFile(index)
                              }
                            }}
                          />
                        </div>
                      </div>
                    </Grid>
                  ))
                }
                <Grid item lg={1} xs={6}>
                  <div className={classes.item}>
                    <br />
                    <label htmlFor="file" className={classes.labelInput}>
                      <Icon
                        color={'#41a2ff'}
                        path={mdiCameraPlus}
                        size={2}
                      />
                      <input
                        id="file"
                        type="file"
                        accept='image/*'
                        name="file"
                        onChange={editMode ? uploadImage : handleChangeFileInput}
                        className={classes.uploadInput}
                      />
                    </label>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </>}
      </CardContent>
    </Card>
  )
}